import { render } from "./curriculo.vue?vue&type=template&id=965edc44&scoped=true"
import script from "./curriculo.vue?vue&type=script&lang=js"
export * from "./curriculo.vue?vue&type=script&lang=js"

import "./curriculo.vue?vue&type=style&index=0&id=965edc44&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-965edc44"]])

export default __exports__